export enum InviteTypeEn {
  OwnerTicket = 1,
  Approver = 2,
  Accepter = 3,
  Handler = 4,
  Guest = 5
}
